import Vue from 'vue';
import Router from 'vue-router';
import create from './create';

Vue.use(Router);

// 全局定时器，在每一次页面离开全部清除
const timer_var = {};

const router = new Router({
  mode: 'history',
  routes: create()
});

const clear = () => {
  Object.keys(timer_var).forEach(item => {
    clearInterval(timer_var[item]);
  });
};


router.beforeEach(async (to, form, next) => {

  // 等待
  await new Promise(resolve => setTimeout(resolve, 0));

  if (window.vm_app) window.vm_app.$store.commit('SET_LOAD_STATE', false);

  const validate = router.getMatchedComponents(to.path).map(c => c.validate).filter(v => v.length > 0);

  for (let i = 0; i < validate.length; i++) {
    const v = validate[i];
    if (v instanceof Array) {

      const info = await Promise.all(v.map(c => c.handle.call(window.vm_app)));

      // 验证不通过
      if (info.filter(i => !!i).length > 0) return next();
    } else {
      const info = await v.call(window.vm_app);
      if (info) return next();
    }
  }

  next();

  let tasks = [];
  let schedule = {};

  router.getMatchedComponents(to.path).forEach(async c => {
    if (c.tasks) tasks = tasks.concat(c.tasks);

    if (c.schedule) {
      for (let i = 0; i < c.schedule.length; i++) {
        const s = c.schedule[i];
        if (!schedule[s.interval]) schedule[s.interval] = [];
        schedule[s.interval] = schedule[s.interval].concat(s.handle);
      }
    }
  });

  // 先清除释放内存
  clear();
  for (const interval in schedule) {
    clearInterval(timer_var[interval]);
    timer_var[interval] = setInterval(() => {
      const s = schedule[interval];
      s.forEach(item => {
        item.call(window.vm_app);
      });
    }, interval * 1000);
  }

  try {

    if (window.vm_app) {
      window.vm_screen_loading = true;
      for (let i = 0; i < tasks.length; i++) {
        const task = tasks[i];
        if (task instanceof Array) {
          await Promise.all(task.map(a => a.handle.call(window.vm_app)));
        } else {
          await task.handle.call(window.vm_app);
        }
      }
      window.vm_app.$store.commit('SET_LOAD_STATE', true);
      window.vm_screen_loading = false;
      return;
    }

    await Promise.resolve().then(async () => {
      window.vm_screen_loading = true;
      for (let i = 0; i < tasks.length; i++) {
        const task = tasks[i];
        if (task instanceof Array) {
          await Promise.all(task.map(a => a.handle.call(window.vm_app)));
        } else {
          await task.handle.call(window.vm_app);
        }
      }
      window.vm_app.$store.commit('SET_LOAD_STATE', true);
      window.vm_screen_loading = false;
    });
  } catch (e) {
    window.vm_app.$store.commit('SET_LOAD_STATE', true);
    window.vm_screen_loading = false;
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js